(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n  <router-outlet>\r\n    \r\n  </router-outlet>\r\n\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/change-password/change-password.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/change-password/change-password.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-spinner></ngx-spinner>\r\n<div class=\"wrapper\">\r\n  <app-nav-menu></app-nav-menu>\r\n\r\n  <div class=\"content-wrapper\">\r\n    <!-- Content Header (Page header) -->\r\n    <!--<section class=\"content-header\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row mb-2\">\r\n          <div class=\"col-sm-6\">\r\n            <h1>Change Password</h1>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </section>-->\r\n    <!-- Main content -->\r\n    <div class=\"white-bg\">\r\n\r\n      <div class=\"content-header\">\r\n\r\n        <div class=\"row mb-2\">\r\n          <div class=\"col-sm-6\">\r\n            <h1 class=\"m-0 text-dark\">Change Password</h1>\r\n          </div><!-- /.col -->\r\n          <!-- /.col -->\r\n          <!-- /.row -->\r\n        </div><!-- /.container-fluid -->\r\n      </div>\r\n      <hr>\r\n      <section class=\"content\">\r\n        <div class=\"innercontents-box\">\r\n          <div class=\"row\">\r\n            <!-- left column -->\r\n            <div class=\"col-md-12\">\r\n              <!-- general form elements -->\r\n              <div class=\"\">\r\n\r\n                <!-- /.card-header -->\r\n                <!-- form start -->\r\n                <form (ngSubmit)=\"f.form.valid && onSubmit(f)\" #f=\"ngForm\" novalidate>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-4\">\r\n                      <div class=\"form-group topspacediv\">\r\n                        <label for=\"exampleInputEmail1\">Password</label>\r\n                        <input type=\"password\" class=\"form-control\" id=\"txt_Password\" placeholder=\"Password\"\r\n                          minlength=\"6\" maxlength=\"20\" name=\"Password\" [(ngModel)]=\"model.Password\" #Password=\"ngModel\"\r\n                          required>\r\n                      </div>\r\n                      <div *ngIf=\"f.submitted && !Password.valid\" class=\"error mt-1\">\r\n                        <div *ngIf=\"Password.errors?.required\">\r\n                          Password is required\r\n                        </div>\r\n                        <div *ngIf=\"Password.errors?.minlength\">\r\n                          Password Password must be greater than or equal to 6 characters\r\n                        </div>\r\n                        <!-- <div *ngIf=\"Password.errors?.maxlength\">\r\n                      Password must be less than 20 character\r\n                    </div> -->\r\n                      </div>\r\n\r\n                      <div class=\"form-group topspacediv\">\r\n                        <label for=\"exampleInputPassword1\">Confirm Password</label>\r\n                        <input type=\"password\" class=\"form-control\" minlength=\"6\" maxlength=\"20\"\r\n                          id=\"txt_confirmPassword\" placeholder=\"Confirm Password\" name=\"confirmPassword\"\r\n                          [(ngModel)]=\"model.ConfirmPassword\" #confirmPassword=\"ngModel\" required>\r\n                      </div>\r\n                      <div *ngIf=\"f.submitted && !confirmPassword.valid\" class=\"error mt-1\">\r\n                        <div *ngIf=\"confirmPassword.errors?.required\">\r\n                          Confirm Password is required\r\n                        </div>\r\n                        <div *ngIf=\"confirmPassword.errors?.minlength\">\r\n                          Confirm Password must be greater than or equal to 6 characters\r\n                        </div>\r\n                        <!-- <div *ngIf=\"confirmPassword.errors?.maxlength\">\r\n                      Confirm  Password must be less than 20 charater\r\n                    </div> -->\r\n                      </div>\r\n\r\n                      <!-- /.card-body -->\r\n                      <div class=\"row topspacediv\">\r\n                        <div class=\"col-md-12 mb-3 mt-3\">\r\n                          <button type=\"submit\" class=\"btn btn-success mr-2\">Submit</button>\r\n\r\n                          <button type=\"button\" (click)=\"f.resetForm();\" class=\"btn btn-black\">Clear</button>\r\n                        </div>\r\n\r\n\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </form>\r\n              </div>\r\n              <!-- /.card -->\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </section>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n<footer class=\"main-footer\">\r\n    Copyright©2019 <a>Dotsquares.com</a>.\r\n    All rights reserved.\r\n  </footer>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/forgot-password/forgot-password.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/forgot-password/forgot-password.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-spinner></ngx-spinner>\r\n\r\n<div class=\"login-page\">\r\n  <div class=\"login-box\">\r\n    <div class=\"login-logo\">\r\n      <img src=\"assets/img/AdminLTELogo.png\" alt=\"SoilHealth Logo\" class=\"brand-image img-circle elevation-3\"\r\n           style=\"opacity: .8\"> <br /> <b>Soil </b>Health\r\n    </div>\r\n    <!-- /.login-logo -->\r\n    <div class=\"card\">\r\n      <div class=\"card-body login-card-body\">\r\n        <!--<p class=\"login-box-msg\">Sign in to start your session</p>-->\r\n        <!--<form action=\"../../index3.html\" method=\"post\">-->\r\n        <form (ngSubmit)=\"f.form.valid && onSubmit()\" #f=\"ngForm\" novalidate>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"email\" class=\"form-control\" maxlength=\"100\"\r\n                   pattern=\"^(([^<>()[\\]\\\\.,;:\\s@\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\']+)*)|(\\'.+\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$\"\r\n                   id=\"txt_Email\" placeholder=\"Email\" name=\"EmailId\" [(ngModel)]=\"model.Email\" #email=\"ngModel\" required>\r\n            <div class=\"input-group-append\">\r\n              <div class=\"input-group-text\">\r\n                <span class=\"fas fa-envelope\"></span>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"f.submitted && !email.valid\" class=\"error\">\r\n              <div *ngIf=\"email.errors?.required\">\r\n                Email address is required\r\n              </div>\r\n              <div *ngIf=\"email.errors?.pattern\">\r\n                Invalid email address\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n\r\n            <!-- /.col -->\r\n            <div class=\"col-3 col-6\">\r\n              <button type=\"submit\" class=\"btn btn-block btn-success\">Submit</button>\r\n            </div>\r\n            <div class=\"col-3 col-6\">\r\n              <button type=\"button\" [routerLink]='[\"/\"]' class=\"btn btn-block btn-black\">Login</button>\r\n            </div>\r\n            <!-- /.col -->\r\n          </div>\r\n        </form>\r\n        <!-- /.social-auth-links -->\r\n      </div>\r\n      <!-- /.login-card-body -->\r\n    </div>\r\n  </div>\r\n  <!-- /.login-box -->\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html":
/*!********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--<h1>Hello, world!</h1>\r\n<p>Welcome to your new single-page application, built with:</p>\r\n<ul>\r\n  <li><a href='https://get.asp.net/'>ASP.NET Core</a> and <a href='https://msdn.microsoft.com/en-us/library/67ef8sbd.aspx'>C#</a> for cross-platform server-side code</li>\r\n  <li><a href='https://angular.io/'>Angular</a> and <a href='http://www.typescriptlang.org/'>TypeScript</a> for client-side code</li>\r\n  <li><a href='http://getbootstrap.com/'>Bootstrap</a> for layout and styling</li>\r\n</ul>\r\n<p>To help you get started, we've also set up:</p>\r\n<ul>\r\n  <li><strong>Client-side navigation</strong>. For example, click <em>Counter</em> then <em>Back</em> to return here.</li>\r\n  <li><strong>Angular CLI integration</strong>. In development mode, there's no need to run <code>ng serve</code>. It runs in the background automatically, so your client-side resources are dynamically built on demand and the page refreshes when you modify any file.</li>\r\n  <li><strong>Efficient production builds</strong>. In production mode, development-time features are disabled, and your <code>dotnet publish</code> configuration automatically invokes <code>ng build</code> to produce minified, ahead-of-time compiled JavaScript files.</li>\r\n</ul>\r\n<p>The <code>ClientApp</code> subdirectory is a standard Angular CLI application. If you open a command prompt in that directory, you can run any <code>ng</code> command (e.g., <code>ng test</code>), or use <code>npm</code> to install extra packages into it.</p>-->\r\n<ngx-spinner></ngx-spinner>\r\n<div class=\"wrapper\">\r\n  <app-nav-menu></app-nav-menu>\r\n\r\n  <div class=\"\">\r\n\r\n    <div class=\"content-wrapper\">\r\n      <!-- Content Header (Page header) -->\r\n      \r\n        <div class=\"white-bg\">\r\n            <div class=\"content-header\">\r\n      \r\n          <div class=\"row mb-2\">\r\n            <div class=\"col-sm-6\">\r\n              <h1 class=\"m-0 text-dark\">Dashboard</h1>\r\n            </div><!-- /.col -->\r\n            <!-- /.col -->\r\n          <!-- /.row -->\r\n        </div><!-- /.container-fluid -->\r\n      </div>\r\n    <hr>\r\n      <!-- /.content-header -->\r\n      <!-- Main content -->\r\n      <section class=\"content\">\r\n        <div class=\"innercontents-box\">\r\n          <!-- Small boxes (Stat box) -->\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-4 col-md-4 col-sm-6 col-6 col-mobile\">\r\n              <!-- small box -->\r\n              <div class=\"small-box bg-info\">\r\n                <div class=\"inner\">\r\n                  <h3>{{PDTopic}}</h3>\r\n                  <p> Podcast Topics Counts</p>\r\n                </div>\r\n                <!--<div class=\"icon\">\r\n                  <i class=\"ion ion-bag\"></i>\r\n                </div>-->\r\n                <a [routerLink]='[\"/PodcastTopic\"]' class=\"small-box-footer\">More info <i class=\"fas fa-arrow-circle-right\"></i></a>\r\n              </div>\r\n            </div>\r\n            <!-- ./col -->\r\n            <div class=\"col-lg-4 col-md-4 col-sm-6 col-6 col-mobile\">\r\n              <!-- small box -->\r\n              <div class=\"small-box bg-success\">\r\n                <div class=\"inner\">\r\n                  <h3>{{PD}}</h3>\r\n                  <p> Podcast Counts</p>\r\n                </div>\r\n                <!--<div class=\"icon\">\r\n                  <i class=\"ion ion-stats-bars\"></i>\r\n                </div>-->\r\n                <a [routerLink]='[\"/Podcast\"]'  class=\"small-box-footer\">More info <i class=\"fas fa-arrow-circle-right\"></i></a>\r\n              </div>\r\n            </div>\r\n           \r\n          </div>\r\n\r\n        </div><!-- /.container-fluid -->\r\n      </section>\r\n      <!-- /.content -->\r\n    </div>\r\n    <!-- /.content-wrapper -->\r\n  </div>\r\n\r\n  <footer class=\"main-footer\">\r\n      Copyright©2019 <a>Dotsquares.com</a>.\r\n      All rights reserved.\r\n    </footer>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/landing-page/landing-page.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/landing-page/landing-page.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<section class=\"container homepageOuter\">\r\n\r\n  <div class=\"innerContainer\">\r\n    <div class=\"col-4 m-col-6\">\r\n      <img src=\"../assets/img/header_for_website.png\" alt=\"nlp logo\" />\r\n      \r\n    </div>\r\n    <div class=\"col-4 m-col-6 text-center\">\r\n     <!-- <img src=\"../../assets/img/nlp.png\" />-->\r\n      <img src=\"../assets/img/AdminLTELogo.png\" alt=\"nlp logo\" width=\"110\">\r\n    </div>\r\n    <div class=\"col-4 text-right m-loginBtnFull\">\r\n      <a [routerLink]='[\"/Login\"]' class=\"LoginBtn \" routerLinkActive=\"active\">\r\n       Admin Login</a>\r\n    </div>\r\n\r\n    <div class=\"InnerContentSec\">\r\n      <p>\r\n        The SOILHEALTH app was funded with support of the Australian Department of Agriculture, Water and the Environment via the Smart Farms Program under the National Landcare Program. It presents essential information about complex aspects of soil health in a digital format and is available for both Android and IOS.\r\n      </p>\r\n\r\n      <p>Privacy Policy</p>\r\n      <p> <a href=\"https://www.soilhealth.net.au/privacypolicy.html\" target=\"_blank\" style=\"cursor: pointer; color: #007bff\">Privacy policy here</a> </p>\r\n      <p>For more detailed information on the topics covered in the SOILHEALTH App</p>\r\n      <p> <a href=\"http://www.soilhealth.com/\"  target=\"_blank\"> For more detailed information \"Click Here\" </a> </p>\r\n    </div>\r\n  </div>\r\n\r\n</section>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-spinner></ngx-spinner>\r\n<div class=\"login-page\">\r\n  <div class=\"login-box\">\r\n    <div class=\"login-logo\">\r\n      <img src=\"assets/img/AdminLTELogo.png\" alt=\"SoilHealth Logo\" class=\"brand-image img-circle elevation-3\"> <br /> <b>Soil </b>Health\r\n    </div>\r\n    <!-- /.login-logo -->\r\n    <div class=\"card\">\r\n      <div class=\"card-body login-card-body\">\r\n        <!--<p class=\"login-box-msg\">Sign in to start your session</p>-->\r\n        <!--<form action=\"../../index3.html\" method=\"post\">-->\r\n        <form (ngSubmit)=\"f.form.valid && onSubmit(f)\" #f=\"ngForm\" novalidate>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"email\" class=\"form-control\" maxlength=\"100\"\r\n                   pattern=\"^(([^<>()[\\]\\\\.,;:\\s@\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\']+)*)|(\\'.+\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$\"\r\n                   id=\"txt_Email\" placeholder=\"Email\" name=\"EmailId\" [(ngModel)]=\"model.Email\" #email=\"ngModel\" required>\r\n            <div class=\"input-group-append\">\r\n              <div class=\"input-group-text\">\r\n                <span class=\"fas fa-envelope\"></span>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"f.submitted && !email.valid\" class=\"error mt-1\">\r\n              <div *ngIf=\"email.errors?.required\">\r\n                Email address is required\r\n              </div>\r\n              <div *ngIf=\"email.errors?.pattern\">\r\n                Invalid email address\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"password\" class=\"form-control\"\r\n                   id=\"txt_Password\" placeholder=\"Password\"\r\n                   name=\"Password\" [(ngModel)]=\"model.Password\" #Password=\"ngModel\" required\r\n                   minlength=\"6\" maxlength=\"20\">\r\n            <div class=\"input-group-append\">\r\n              <div class=\"input-group-text\">\r\n                <span class=\"fas fa-lock\"></span>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"f.submitted && !Password.valid\" class=\"error mt-1\">\r\n              <div *ngIf=\"Password.errors?.required\">\r\n                Password is required\r\n              </div>\r\n              <div *ngIf=\"Password.errors?.minlength\">\r\n                Invalid Password\r\n              </div>\r\n              <!-- <div *ngIf=\"Password.errors?.maxlength\">\r\n                Password must be less than 20 character\r\n              </div> -->\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-7\">\r\n              <div class=\"icheck-primary\">\r\n                <input type=\"checkbox\" id=\"remember\" name=\"remember\" [(ngModel)]=\"model.remember\" #remember=\"ngModel\">\r\n                <label for=\"remember\">\r\n                  Remember Me\r\n                </label>\r\n              </div>\r\n            </div>\r\n            <!-- /.col -->\r\n            <div class=\"col-5\">\r\n              <button type=\"submit\" class=\"btn btn-block btn-success\">Login</button>\r\n            </div>\r\n            <!-- /.col -->\r\n          </div>\r\n        </form>\r\n        <!-- /.social-auth-links -->\r\n        <p class=\"mb-1 text-center mt-4\">\r\n          <a [routerLink]='[\"/ForgotPassword\"]'>I forgot my password</a>\r\n        </p>\r\n      </div>\r\n      <!-- /.login-card-body -->\r\n    </div>\r\n  </div>\r\n  <!-- /.login-box -->\r\n</div>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/nav-menu/nav-menu.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/nav-menu/nav-menu.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--<header>\r\n  <nav class='navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3'>\r\n    <div class=\"container\">\r\n      <a class=\"navbar-brand\" [routerLink]='[\"/\"]'>Soil_Health</a>\r\n      <button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\".navbar-collapse\" aria-label=\"Toggle navigation\"\r\n              [attr.aria-expanded]=\"isExpanded\" (click)=\"toggle()\">\r\n        <span class=\"navbar-toggler-icon\"></span>\r\n      </button>\r\n      <div class=\"navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse\" [ngClass]='{\"show\": isExpanded}'>\r\n        <ul class=\"navbar-nav flex-grow\">\r\n          <li class=\"nav-item\" [routerLinkActive]='[\"link-active\"]' [routerLinkActiveOptions]='{ exact: true }'>\r\n            <a class=\"nav-link text-dark\" [routerLink]='[\"/\"]'>Home</a>\r\n          </li>\r\n          <li class=\"nav-item\" [routerLinkActive]='[\"link-active\"]'>\r\n            <a class=\"nav-link text-dark\" [routerLink]='[\"/counter\"]'>Counter</a>\r\n          </li>\r\n          <li class=\"nav-item\" [routerLinkActive]='[\"link-active\"]'>\r\n            <a class=\"nav-link text-dark\" [routerLink]='[\"/fetch-data\"]'>Fetch data</a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </nav>\r\n</header>-->\r\n<!-- Navbar -->\r\n<nav class=\"main-header navbar navbar-expand navbar-white navbar-light\">\r\n  <!-- Left navbar links -->\r\n  <ul class=\"navbar-nav\">\r\n    <li class=\"nav-item\">\r\n      <a class=\"nav-link\" data-widget=\"pushmenu\" href=\"#\"><i class=\"fas fa-bars\"></i></a>\r\n    </li>\r\n  </ul>\r\n\r\n\r\n  <ul class=\"navbar-nav ml-auto\" >\r\n    <li class=\"nav-item\" style=\"cursor:pointer\" >\r\n      <a class=\"nav-link\" (click)=\"Logout()\" >\r\n        Logout &nbsp; <i class=\"fas fa-sign-out-alt\"></i>\r\n      </a>\r\n    </li>\r\n  </ul>\r\n\r\n</nav>\r\n<!-- /.navbar -->\r\n<!-- Main Sidebar Container -->\r\n<aside class=\"main-sidebar sidebar-dark-primary elevation-4\">\r\n  <!-- Brand Logo -->\r\n  <div class=\"brand-link\">\r\n    <img src=\"assets/img/AdminLTELogo.png\" alt=\"AdminLTE Logo\" class=\"brand-image img-circle elevation-3\"\r\n         style=\"opacity: .8\">\r\n    <span class=\"brand-text font-weight-light\">Soil Health</span>\r\n  </div>\r\n  <!-- Sidebar -->\r\n  <div class=\"sidebar\">\r\n    <!-- Sidebar user panel (optional) -->\r\n    <div class=\"user-panel mt-3 pb-3 mb-3 d-flex\">\r\n      <div class=\"image\">\r\n        <img src=\"assets/img/user8-128x128.jpg\" class=\"img-circle elevation-2\" alt=\"User Image\">\r\n      </div>\r\n      <div class=\"info\">\r\n        <span class=\"text-white\">Admin</span>\r\n      </div>\r\n    </div>\r\n    <!-- Sidebar Menu -->\r\n    <nav class=\"mt-2\">\r\n      <ul class=\"nav nav-pills nav-sidebar flex-column showdasktop\"  >\r\n        <!-- Add icons to the links using the .nav-icon class\r\n        with font-awesome or any other icon font library -->\r\n        <li class=\"nav-item \">\r\n          <a [routerLink]='[\"/Dashboard\"]' class=\"nav-link \" routerLinkActive=\"active\">\r\n            <i class=\"nav-icon fa fa-home\"></i>\r\n            <p>\r\n              Dashboard\r\n              <!--<i class=\"right fas fa-angle-left\"></i>-->\r\n            </p>\r\n          </a>\r\n\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a [routerLink]='[\"/PodcastTopic\"]' class=\"nav-link\" routerLinkActive=\"active\">\r\n            <i class=\"nav-icon fa fa-podcast\"></i>\r\n            <p>\r\n              Podcast Topics\r\n              <!--<span class=\"right badge badge-danger\">New</span>-->\r\n            </p>\r\n          </a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a [routerLink]='[\"/Podcast\"]' class=\"nav-link\" routerLinkActive=\"active\">\r\n            <i class=\"nav-icon fa fa-podcast\"></i>\r\n            <p>\r\n              Podcast\r\n              <!--<span class=\"right badge badge-danger\">New</span>-->\r\n            </p>\r\n          </a>\r\n        </li>\r\n\r\n        <li class=\"nav-item\">\r\n          <a [routerLink]='[\"/ChangePassword\"]' class=\"nav-link\" routerLinkActive=\"active\">\r\n            <i class=\"nav-icon fa fa-key\"></i>\r\n            <p>\r\n              Change Password\r\n              <!--<span class=\"right badge badge-danger\">New</span>-->\r\n            </p>\r\n          </a>\r\n        </li>\r\n\r\n      </ul>\r\n\r\n      <ul class=\"nav nav-pills nav-sidebar flex-column showmobile\" data-widget=\"pushmenu\" >\r\n          <!-- Add icons to the links using the .nav-icon class\r\n          with font-awesome or any other icon font library -->\r\n          <li class=\"nav-item \">\r\n            <a [routerLink]='[\"/Dashboard\"]' class=\"nav-link \" routerLinkActive=\"active\">\r\n              <i class=\"nav-icon fa fa-home\"></i>\r\n              <p>\r\n                Dashboard\r\n                <!--<i class=\"right fas fa-angle-left\"></i>-->\r\n              </p>\r\n            </a>\r\n  \r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a [routerLink]='[\"/PodcastTopic\"]' class=\"nav-link\" routerLinkActive=\"active\">\r\n              <i class=\"nav-icon fa fa-podcast\"></i>\r\n              <p>\r\n                Podcast Topics\r\n                <!--<span class=\"right badge badge-danger\">New</span>-->\r\n              </p>\r\n            </a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a [routerLink]='[\"/Podcast\"]' class=\"nav-link\" routerLinkActive=\"active\">\r\n              <i class=\"nav-icon fa fa-podcast\"></i>\r\n              <p>\r\n                Podcast\r\n                <!--<span class=\"right badge badge-danger\">New</span>-->\r\n              </p>\r\n            </a>\r\n          </li>\r\n  \r\n          <li class=\"nav-item\">\r\n            <a [routerLink]='[\"/ChangePassword\"]' class=\"nav-link\" routerLinkActive=\"active\">\r\n              <i class=\"nav-icon fa fa-key\"></i>\r\n              <p>\r\n                Change Password\r\n                <!--<span class=\"right badge badge-danger\">New</span>-->\r\n              </p>\r\n            </a>\r\n          </li>\r\n  \r\n        </ul>\r\n    </nav>\r\n    <!-- /.sidebar-menu -->\r\n  </div>\r\n  <!-- /.sidebar -->\r\n\r\n  \r\n</aside>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/podcast-topic/podcast-topic.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/podcast-topic/podcast-topic.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-spinner></ngx-spinner>\r\n\r\n<div class=\"wrapper\">\r\n  <app-nav-menu></app-nav-menu>\r\n\r\n  <div class=\"content-wrapper\">\r\n    <div class=\"white-bg\">\r\n      <!-- Content Header (Page header) -->\r\n      <!--<section class=\"content-header\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row mb-2\">\r\n          <div class=\"col-sm-6\">\r\n            <h1>Podcast Topic</h1>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </section>-->\r\n      <!-- Form to add podcast image content -->\r\n\r\n      <div class=\"content-header\">\r\n\r\n        <div class=\"row mb-2\">\r\n          <div class=\"col-sm-6\">\r\n            <h1 class=\"m-0 text-dark\">Podcast Topic</h1>\r\n          </div><!-- /.col -->\r\n          <!-- /.col -->\r\n          <!-- /.row -->\r\n        </div><!-- /.container-fluid -->\r\n      </div>\r\n      <hr>\r\n      <section class=\"content\">\r\n        <div class=\"innercontents-box\">\r\n          <div class=\"row\">\r\n            <!-- left column -->\r\n            <div class=\"col-md-12\">\r\n              <!-- general form elements -->\r\n\r\n\r\n              <!-- /.card-header -->\r\n              <!-- form start -->\r\n              <form (ngSubmit)=\"f.form.valid && onSubmit(f)\" #f=\"ngForm\" novalidate>\r\n\r\n\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-4\">\r\n                    <div class=\"form-group\">\r\n                      <label for=\"exampleInputEmail1\">Topic</label>\r\n                      <input type=\"text\" class=\"form-control\" id=\"txt_Password\" placeholder=\"Topic\" maxlength=\"50\"\r\n                        name=\"TopicTitle\" [(ngModel)]=\"model.TopicTitle\" #TopicTitle=\"ngModel\" required>\r\n                    </div>\r\n                    <div *ngIf=\"f.submitted && !TopicTitle.valid\" class=\"error mt-1\">\r\n                      <div *ngIf=\"TopicTitle.errors?.required\">\r\n                        Topic is required\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div class=\"col-md-4\">\r\n                    <div class=\"form-group topspace3\">\r\n                      <label for=\"exampleInputEmail1\">Thumbnail</label><br>\r\n\r\n                      <input type=\"file\" (change)=\"fileChangeEvent($event)\" required #myInput />\r\n\r\n\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row topspace5\">\r\n                    <!-- /.card-body -->\r\n                    <div class=\"col-md-6 col-6\">\r\n                      <button type=\"submit\" class=\"btn btn-success pull-right\">Submit</button>\r\n                    </div>\r\n                    <div class=\"col-md-6 col-6\">\r\n                      <button type=\"button\" (click)=\"reset(f)\" class=\"btn btn-black\">Clear</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <image-cropper [imageChangedEvent]=\"imageChangedEvent\" [maintainAspectRatio]=\"true\"\r\n                      [aspectRatio]=\"1 / 1\" [resizeToWidth]=\"128\" format=\"png\" (imageCropped)=\"imageCropped($event)\"\r\n                      (imageLoaded)=\"imageLoaded()\" (cropperReady)=\"cropperReady()\"\r\n                      (loadImageFailed)=\"loadImageFailed()\"></image-cropper>\r\n\r\n                    <img [src]=\"croppedImage\" name=\"ThumbnailImage\" />\r\n                  </div>\r\n                </div>\r\n\r\n              </form>\r\n\r\n              <!-- /.card -->\r\n            </div>\r\n          </div>\r\n\r\n\r\n          <div class=\"row\">\r\n\r\n            <!--<mat-form-field>\r\n              <input matInput (keyup)=\"applyFilter($event.target.value)\" placeholder=\"Filter\">\r\n            </mat-form-field>-->\r\n            <div class=\"col-md-12\">\r\n              <div class=\"mat-elevation-z8 innertabledata\" *ngIf=\"dataSource && dataSource.data\">\r\n\r\n                <!--{{dataSource.data | json}}-->\r\n                <mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8 table table-bordered\" cdkDropList #table1\r\n                  #list1=\"cdkDropList\" [cdkDropListData]=\"dataSource.data\" (cdkDropListDropped)=\"drop($event)\"\r\n                  id=\"table1\">\r\n\r\n                  <!--- Note that these columns can be defined in any order.\r\n      The actual rendered columns are set as a property on the row definition\" -->\r\n\r\n                  <ng-container matColumnDef=\"DisplayOrder\">\r\n                    <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>\r\n                   <!-- <mat-cell *matCellDef=\"let element\"  let i = index;> {{element.displayOrder}} </mat-cell>-->\r\n                    <mat-cell *matCellDef=\"let element; let i = index;\"> {{i+1}} </mat-cell>\r\n                  </ng-container>\r\n\r\n\r\n                  <ng-container matColumnDef=\"Topic\">\r\n                    <mat-header-cell *matHeaderCellDef class=\"tabletopic\"> Topic </mat-header-cell>\r\n                    <mat-cell *matCellDef=\"let element\"> {{element.topicTitle}} </mat-cell>\r\n                  </ng-container>\r\n\r\n\r\n                  <ng-container matColumnDef=\"Thumbnail\">\r\n                    <mat-header-cell *matHeaderCellDef> Thumbnail </mat-header-cell>\r\n                    <mat-cell *matCellDef=\"let element\">\r\n                      <img src=\"Images/{{element.thumbnail}}\" border=\"1\" height=\"45\" width=\"45\">\r\n\r\n                    </mat-cell>\r\n                  </ng-container>\r\n\r\n\r\n                  <ng-container matColumnDef=\"Action\">\r\n                    <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>\r\n                    <mat-cell *matCellDef=\"let element\">\r\n                      <mat-icon (click)=\"EditPodcastTopic(element.id)\" class=\"edit-btn\">edit</mat-icon>\r\n                      <mat-icon (click)=\"openDeleteModal(Delete,element.id)\" class=\"delete-btn\">delete</mat-icon>\r\n                    </mat-cell>\r\n                  </ng-container>\r\n\r\n                  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\r\n                  <mat-row *matRowDef=\"let row; columns: displayedColumns;\" cdkDrag></mat-row>\r\n                </mat-table>\r\n\r\n                <mat-paginator class=\"marginless-paginator-range-label\" #paginator [pageIndex]=\"0\" [pageSize]=\"50\">\r\n                </mat-paginator>\r\n\r\n\r\n                <div *ngIf=\"dataSource && dataSource.data &&  dataSource.data.length==0\">\r\n                  No data found\r\n                </div>\r\n\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </section>\r\n\r\n\r\n    </div>\r\n  </div>\r\n  <footer class=\"main-footer\">\r\n    Copyright©2019 <a>Dotsquares.com</a>.\r\n    All rights reserved.\r\n  </footer>\r\n</div>\r\n\r\n<!-- Image View Modal -->\r\n<!--<ng-template #template>\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title pull-left\">{{title}}</h4>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <img [src]=\"ViewImage\" border=\"1\" height=\"100\" width=\"100\" />\r\n  </div>\r\n</ng-template>-->\r\n\r\n\r\n<ng-template #Delete>\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title pull-left\">Delete</h4>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body text-center\">\r\n    <input type=\"hidden\" id=\"id\" name=\"id\" [value]=\"id\" />\r\n    <p>Are you sure to delete this podcast topic ?</p>\r\n    <button type=\"button\" class=\"btn btn-default \" (click)=\"confirm(id)\">Yes</button>\r\n    <button type=\"button\" class=\"btn btn-primary ml-2\" (click)=\"decline()\">No</button>\r\n  </div>\r\n</ng-template>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/podcast/podcast.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/podcast/podcast.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-spinner></ngx-spinner>\r\n\r\n<div class=\"wrapper\">\r\n  <app-nav-menu></app-nav-menu>\r\n\r\n  <div class=\"content-wrapper\">\r\n    <!-- Content Header (Page header) -->\r\n    <!--<section class=\"content-header\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row mb-2\">\r\n          <div class=\"col-sm-6\">\r\n            <h1>Podcast</h1>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </section>-->\r\n    <div class=\"white-bg\">\r\n      <div class=\"content-header\">\r\n\r\n        <div class=\"row mb-2\">\r\n          <div class=\"col-sm-6\">\r\n            <h1 class=\"m-0 text-dark\">Podcast</h1>\r\n          </div><!-- /.col -->\r\n          <!-- /.col -->\r\n          <!-- /.row -->\r\n        </div><!-- /.container-fluid -->\r\n      </div>\r\n      <hr>\r\n      <!-- Form to add podcast image content -->\r\n      <section class=\"content\">\r\n        <div class=\"innercontents-box\">\r\n          <div class=\"\">\r\n            <div class=\"row\">\r\n              <!-- left column -->\r\n              <div class=\"col-md-12\">\r\n                <!-- general form elements -->\r\n                <div class=\"\">\r\n\r\n                  <!-- /.card-header -->\r\n                  <!-- form start -->\r\n                  <form name=\"form\" (ngSubmit)=\"f.form.valid && onSubmit(f)\" #f=\"ngForm\" novalidate>\r\n\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <div class=\"row\">\r\n\r\n                          <div class=\"col-md-12\">\r\n                            <div class=\"form-group\">\r\n                              <label for=\"exampleInputEmail1\">Podcast Topic</label><br />\r\n\r\n                              <select class=\"form-control\" [(ngModel)]=\"model.topicId\" #topicId=\"ngModel\" name=\"topicId\"\r\n                                required>\r\n                                <!--<option>Select Topic</option>-->\r\n                                <option value=\"\">Select Topic </option>\r\n                                <option *ngFor=\"let item of topiclist\" [value]=\"item.id\">\r\n                                  {{item.topicTitle}}\r\n                                </option>\r\n                              </select>\r\n                              <!--  <mat-form-field>\r\n                         <mat-label>Favorite food</mat-label>\r\n                         <mat-select [(ngModel)]=\"selectedValue\" name=\"food\"  [ngModelOptions]=\"{standalone: true}\">\r\n                           <mat-option *ngFor=\"let item of topiclist\" [value]=\"food.value\" >\r\n                             {{food.viewValue}}\r\n                           </mat-option>\r\n                         </mat-select>\r\n                        <mat-select name=\"topicId\" [(ngModel)]=\"model.topicId\" #topicId=\"ngModel\" required\r\n                                     [ngModelOptions]=\"{standalone: true}\">\r\n\r\n                           <mat-option *ngFor=\"let item of topiclist\" [value]=\"item.id\" name=\"item\">\r\n                             {{item.topiTitle}}\r\n                           </mat-option>\r\n                         </mat-select>\r\n                                            </mat-form-field>-->\r\n\r\n                            </div>\r\n                            <div *ngIf=\"f.submitted && !topicId.valid\" class=\"error mt-1\" maxlength=\"50\">\r\n                              <div *ngIf=\"topicId.errors?.required\">\r\n                                Podcast Topic is required\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n\r\n                          <div class=\"col-md-12\">\r\n                            <!-- /.card-body -->\r\n                            <div class=\"form-group topspace0\">\r\n                              <label for=\"exampleInputEmail1\">Audio file</label><br />\r\n                              <input type=\"file\" (change)=\"fileChangeEvent($event); \" accept=\"audio/*\" #myInput\r\n                                     required />\r\n                            </div>\r\n\r\n                          </div>\r\n\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n                        <!-- /.card-body -->\r\n                        <div class=\"form-group\">\r\n                          <label for=\"exampleInputEmail1\">Description</label>\r\n                          <textarea type=\"text\" class=\"form-control\" id=\"txt_desc\" placeholder=\"Description\" rows=\"4\"\r\n                            maxlength=\"500\" name=\"Description\" [(ngModel)]=\"model.Description\" #Description=\"ngModel\"\r\n                            required>\r\n                        </textarea>\r\n                        </div>\r\n                        <div *ngIf=\"f.submitted && !Description.valid\" class=\"error mt-1\" maxlength=\"50\">\r\n                          <div *ngIf=\"Description.errors?.required\">\r\n                            Description is required\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n\r\n\r\n                      <div class=\"col-md-12 mb-5 mdspace-top topspace5\">\r\n                        <!-- /.card-body -->\r\n                        <div class=\"\">\r\n                          <button type=\"submit\" class=\"btn btn-success pull-right mr-2\">Submit</button>\r\n                          <button type=\"button\" (click)=\"reset(f);\" class=\"btn btn-black\">Clear</button>\r\n                        </div>\r\n                      </div>\r\n\r\n                    </div>\r\n\r\n                  </form>\r\n                </div>\r\n                <!-- /.card -->\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"row mb-3\">\r\n            <div class=\"col-md-6\">\r\n              <div class=\"inlinefomrtag\">\r\n                <div class=\"row\">\r\n              <!-- <mat-form-field>\r\n                <input matInput (keyup)=\"applyFilter($event.target.value)\" placeholder=\"Filter\">  -->\r\n              <label class=\"col-sm-4 col-md-6 col-form-label\">Filter by Podcast Topic</label>\r\n<div class=\"col-sm-5 col-md-6\">\r\n              <select (change)=\"applyFilter($event.target.value)\" class=\"form-control \">\r\n                  <option [value]=\"\">\r\n                    Select All\r\n                  </option>\r\n                  <option *ngFor=\"let item of topiclist\" [value]=\"item.topicTitle\">\r\n                    {{item.topicTitle}}\r\n                  </option>\r\n                </select>\r\n              </div>\r\n              </div>\r\n              </div>\r\n            </div>\r\n           \r\n          </div>\r\n          <!-- </mat-form-field> -->\r\n          <div class=\"box-body table-responsive innertabledata\" *ngIf=\"PodcastdataSource\">\r\n            <mat-table [dataSource]=\"PodcastdataSource\" class=\"mat-elevation-z8 table table-bordered\" cdkDropList\r\n              #table1 #list1=\"cdkDropList\" [cdkDropListData]=\"PodcastdataSource\" (cdkDropListDropped)=\"drop($event)\"\r\n              id=\"table1\">\r\n              <!--<table mat-table #table1 [dataSource]=\"PodcastdataSource\" class=\"mat-elevation-z8\"\r\n      cdkDropList\r\n      [cdkDropListData]=\"PodcastdataSource\"\r\n      (cdkDropListDropped)=\"drop($event)\">-->\r\n              <!--- Note that these columns can be defined in any order.\r\n      The actual rendered columns are set as a property on the row definition\" -->\r\n\r\n              <ng-container matColumnDef=\"DisplayOrder\">\r\n                <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>\r\n                <mat-cell *matCellDef=\"let element;let i = index\" cdkDragHandle> {{i+1}} </mat-cell>\r\n                <!--<th mat-header-cell *matHeaderCellDef> No. </th>\r\n        <td mat-cell *matCellDef=\"let element\">\r\n          <mat-icon cdkDragHandle>reorder</mat-icon>\r\n        </td>-->\r\n              </ng-container>\r\n\r\n\r\n              <ng-container matColumnDef=\"Topic\">\r\n                <mat-header-cell *matHeaderCellDef> Topic </mat-header-cell>\r\n                <mat-cell *matCellDef=\"let element\"> {{element.topicTitle}} </mat-cell>\r\n                <!--<th mat-header-cell *matHeaderCellDef> Topic </th>\r\n        <td mat-cell *matCellDef=\"let element\"> {{element.topicTitle}} </td>-->\r\n              </ng-container>\r\n\r\n\r\n              <ng-container matColumnDef=\"File\">\r\n                <!--<th mat-header-cell *matHeaderCellDef> File </th>\r\n         <td mat-cell *matCellDef=\"let element\">test\r\n        <img *ngIf=\"element.file!=null\" src=\"assets/img/audio-file-icon-9.jpg\" border=\"1\" height=\"64\" width=\"64\"  /> </td>-->\r\n                <mat-header-cell *matHeaderCellDef> Audio file </mat-header-cell>\r\n                <mat-cell *matCellDef=\"let element\">\r\n                  <!--<img *ngIf=\"element.file!=null\" src=\"assets/img/audio-file-icon-9.jpg\"\r\n                       border=\"1\" height=\"64\" width=\"64\" title=\"{{element.file}}\" />-->\r\n                  <!--<img src=\"Audio/{{element.file}}\" border=\"1\" height=\"64\" width=\"64\" (click)=\"openModal(template,element)\">-->\r\n                  <a href=\"http://soilhealth.net.au/Audio/{{element.file}}\" target=\"_blank\">\r\n                    <img *ngIf=\"element.file!=null\" src=\"assets/img/audio-file-icon-9.jpg\" border=\"1\" height=\"45\"\r\n                      width=\"45\" title=\"{{element.file}}\" />\r\n                  </a>\r\n\r\n\r\n                </mat-cell>-->\r\n              </ng-container>\r\n\r\n\r\n              <ng-container matColumnDef=\"Action\">\r\n                <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>\r\n                <mat-cell *matCellDef=\"let element\">\r\n                  <mat-icon style=\"cursor:pointer\" (click)=\"EditPodcastTopic(element.id)\" class=\"edit-btn\">edit\r\n                  </mat-icon>\r\n                  <mat-icon style=\"cursor:pointer\" (click)=\"openDeleteModal(Delete,element.id)\" class=\"delete-btn\">\r\n                    delete</mat-icon>\r\n                </mat-cell>\r\n              </ng-container>\r\n\r\n              <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\r\n              <mat-row *matRowDef=\"let row; columns: displayedColumns;\" cdkDrag [cdkDragData]=\"row\"></mat-row>\r\n\r\n              <!--<tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" cdkDrag [cdkDragData]=\"row\"></tr>-->\r\n            </mat-table>\r\n\r\n            \r\n            <div *ngIf=\"renderedRows==0\">\r\n                No data found\r\n              </div>\r\n\r\n            <div *ngIf=\"PodcastdataSource && PodcastdataSource.data.length==0\">\r\n              No data found\r\n            </div>\r\n            <mat-paginator class=\"marginless-paginator-range-label\" #paginator [pageIndex]=\"0\" [pageSize]=\"50\">\r\n            </mat-paginator>\r\n          </div>\r\n        </div>\r\n      </section>\r\n    </div>\r\n  </div>\r\n  <footer class=\"main-footer\">\r\n    Copyright©2019 <a>Dotsquares.com</a>.\r\n    All rights reserved.\r\n  </footer>\r\n</div>\r\n\r\n\r\n<!-- Image View Modal -->\r\n<ng-template #template>\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title pull-left\">{{title}}</h4>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <img [src]=\"ViewImage\" border=\"1\" height=\"100\" width=\"100\" />\r\n  </div>\r\n</ng-template>\r\n\r\n\r\n<ng-template #Delete>\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title pull-left\">Delete</h4>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body text-center\">\r\n    <input type=\"hidden\" id=\"id\" name=\"id\" [value]=\"id\" />\r\n    <p>Are you sure to delete this podcast ?</p>\r\n    <div class=\"container\">\r\n      <button type=\"button\" class=\"btn btn-default \" (click)=\"confirm(id)\">Yes</button>\r\n      <button type=\"button\" class=\"btn btn-primary ml-2\" (click)=\"decline()\">No</button>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/privacy-policy/privacy-policy.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/privacy-policy/privacy-policy.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<section class=\"container\">\r\n  \r\n  <img src=\"../assets/img/header_for_website.png\" alt=\"nlp logo\" />\r\n  <h1>Privacy Policy 12/02/2022</h1>\r\n  <p>\r\n    We recognise that privacy is important. This Privacy Policy applies to all apps (Android and IOS) called Soil Health published by Lynette Abbott and our website(s). We have created this policy to explain our privacy practices so that you can understand what information about you is collected, what it is used for and when it is disclosed. We collect information from you to provide a better user experience. We may use your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our service, products, or marketing. With your consent to this policy, your usage, and various other operational statistics will be collected.\r\n  </p>\r\n  <h1>Information Collection and Use</h1>\r\n  <p>We may collect non-personal information about users whenever they interact with our application. This non-personal information is in a form that does not, on its own, permit direct association with any specific individual.</p>\r\n  <p>\r\n    Like most web sites, we track usage patterns on our website on an anonymous aggregate basis. Each time you visit our website a web server makes a record of your visit. Specifically, it records the web server that show the IP address of the visitor, date, time, and pages visited. Your identity cannot reasonably be ascertained from this information.\r\n</p>\r\n<p>    You should be aware that when you are on soil health site you could be directed to other sites where the personal information collected is beyond our control. The privacy policy of the new site will govern the information obtained from you on that site.\r\n  </p>\r\n\r\n  <h1>EU User Consent Policy</h1>\r\n\r\n  <p>We include certain disclosures to users in the European Economic Area and obtain their consent to use cookies or other local storage, where legally required. This policy reflects the requirements of the EU ePrivacy Directive and the General Data Protection Regulation.</p>\r\n\r\n  <p>Learn about EU User Consent Policy:</p>\r\n  <p> <a href=\"https://www.google.com/about/company/user-consent-policy/\">EU User Consent Policy</a> </p>\r\n\r\n  <h1>How Your Information May Be Disclosed</h1>\r\n\r\n  <p>Your non-personal information may be amalgamated and may be used for statistical reporting purposes.</p>\r\n  <p>Your non-personal information may be disclosed to third-party service providers (Firebase) and the use of that data is governed by their privacy practices.</p>\r\n\r\n  <h1>Privacy Policy of Third-Party Service Providers Used by the App</h1>\r\n  <p>The App uses third party services that may collect information used to identify you, which may include, number of users and sessions, session duration, operating system, device model, geographical location, first launches, App opens and App updates. The third-party services may also collect information relating to bugs or software crashes that may occur. The third-party services used are Google Analytics for Firebase, Firebase Crashlytics and Google Play (Android).</p>\r\n\r\n  <p> <a href=\"https://firebase.google.com/support/privacy\">Google Analytics for Firebase Privacy Policy</a> </p>\r\n  <p> <a href=\"https://policies.google.com/privacy?hl=en-US\">Google Play Privacy Policy</a> </p>\r\n\r\n  <p>Users can opt out of the Firebase features through applicable device settings or through the deletion of the App.</p>\r\n\r\n  <h1>Privacy Policy Updates</h1>\r\n  <p>Users are encouraged to check on our website periodically to check for any updates to this policy.</p>\r\n\r\n  <h1>Data Security</h1>\r\n  <p>We take the security of your data very seriously. We do not collect personal information and we employ administrative and electronic measures to protect your non-personal information from unauthorized access and use. We shall delete the information when it is no longer needed.</p>\r\n\r\n  <h1>Contacting Us</h1>\r\n  <p>Lynette Abbott</p>\r\n  <p><a href=\"mailto:lynette.abbott@uwa.edu.au\" style=\"padding:0px\">lynette.abbott@uwa.edu.au</a></p>\r\n\r\n\r\n\r\n</section>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/reset-password/reset-password.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/reset-password/reset-password.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-spinner></ngx-spinner>\r\n<div class=\"login-page\">\r\n  <div class=\"login-box\">\r\n    <div class=\"login-logo\">\r\n      <img src=\"assets/img/AdminLTELogo.png\" alt=\"SoilHealth Logo\" class=\"brand-image img-circle elevation-3\"\r\n           style=\"opacity: .8\"> <br /> <b>Soil </b>Health\r\n    </div>\r\n    <!-- /.login-logo -->\r\n    <div class=\"card\">\r\n      <div class=\"card-body login-card-body\">\r\n        <!--<p class=\"login-box-msg\">Sign in to start your session</p>-->\r\n        <!--<form action=\"../../index3.html\" method=\"post\">-->\r\n        <form (ngSubmit)=\"f.form.valid && onSubmit()\" #f=\"ngForm\" novalidate>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"password\" class=\"form-control\" minlength=\"6\" maxlength=\"20\"\r\n                   id=\"txt_Password\" placeholder=\"Password\"\r\n                   name=\"Password\" [(ngModel)]=\"model.Password\" #Password=\"ngModel\" required>\r\n            <div class=\"input-group-append\">\r\n              <div class=\"input-group-text\">\r\n                <span class=\"fas fa-lock\"></span>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"f.submitted && !Password.valid\" class=\"error mt-1\">\r\n              <div *ngIf=\"Password.errors?.required\">\r\n                Password is required\r\n              </div>\r\n              <div *ngIf=\"Password.errors?.minlength\">\r\n                Password must be greater than 6 character\r\n              </div>\r\n              <div *ngIf=\"Password.errors?.maxlength\">\r\n                Password must be less than 20 character\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"password\" class=\"form-control\" minlength=\"6\" maxlength=\"20\"\r\n                   id=\"txt_confirmPassword\" placeholder=\"Confirm Password\"\r\n                   name=\"confirmPassword\" [(ngModel)]=\"model.ConfirmPassword\" #confirmPassword=\"ngModel\" required>\r\n            <div class=\"input-group-append\">\r\n              <div class=\"input-group-text\">\r\n                <span class=\"fas fa-lock\"></span>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"f.submitted && !confirmPassword.valid\" class=\"error mt-1\">\r\n              <div *ngIf=\"confirmPassword.errors?.required\">\r\n                Password is required\r\n              </div>\r\n              <div *ngIf=\"confirmPassword.errors?.minlength\">\r\n                Password must be greater than 6 character\r\n              </div>\r\n              <div *ngIf=\"confirmPassword.errors?.maxlength\">\r\n                Password must be less than 20 character\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n\r\n            <!-- /.col -->\r\n            <div class=\"col-4 col-12\">\r\n              <button type=\"submit\" class=\"btn btn-block btn-success\">Submit</button>\r\n            </div>\r\n            <!-- /.col -->\r\n          </div>\r\n        </form>\r\n      </div>\r\n      <!-- /.login-card-body -->\r\n    </div>\r\n  </div>\r\n  <!-- /.login-box -->\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/_gaurd/auth.guard.ts":
/*!**************************************!*\
  !*** ./src/app/_gaurd/auth.guard.ts ***!
  \**************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");




let AuthGuard = class AuthGuard {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    canActivate(route, state) {
        const currentUser = this.authenticationService.currentSyncUser();
        if (currentUser) {
            if (currentUser.token != 'Password invalid') { // logged in so return true
                return true;
            }
            else {
                return false;
            }
        }
        else {
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/']);
            return false;
        }
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' })
], AuthGuard);



/***/ }),

/***/ "./src/app/_helpers/error.interceptor.ts":
/*!***********************************************!*\
  !*** ./src/app/_helpers/error.interceptor.ts ***!
  \***********************************************/
/*! exports provided: ErrorInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorInterceptor", function() { return ErrorInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");






let ErrorInterceptor = class ErrorInterceptor {
    constructor(authenticationService, toastr) {
        this.authenticationService = authenticationService;
        this.toastr = toastr;
    }
    intercept(request, next) {
        return next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                // this.authenticationService.logout();
                // location.reload(true);
                console.log("Testing ");
            }
            else if (err.status === 0) {
                this.toastr.warning(err.statusText);
            }
            const error = err.error.message || err.statusText;
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["throwError"])(error);
        }));
    }
};
ErrorInterceptor.ctorParameters = () => [
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] }
];
ErrorInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], ErrorInterceptor);



/***/ }),

/***/ "./src/app/_helpers/jwt.interceptor.ts":
/*!*********************************************!*\
  !*** ./src/app/_helpers/jwt.interceptor.ts ***!
  \*********************************************/
/*! exports provided: JwtInterceptor, encrypt, decrypt */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JwtInterceptor", function() { return JwtInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encrypt", function() { return encrypt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrypt", function() { return decrypt; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_5__);






let JwtInterceptor = class JwtInterceptor {
    constructor(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
        this.EndPoint = "https://localhost:44316/";
    }
    intercept(request, next) {
        // add auth header with jwt if user is logged in and request is to api url
        const currentUser = this.authenticationService.currentUserValue;
        const isLoggedIn = currentUser && currentUser.token ? currentUser.token : '';
        const isApiUrl = request.url.startsWith(this.EndPoint);
        if (isLoggedIn) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
            //console.log(request.headers);                     
        }
        return next.handle(request);
    }
};
JwtInterceptor.ctorParameters = () => [
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
JwtInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], JwtInterceptor);

function encrypt(data) {
    let secret = (src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].SecretKey || "");
    return crypto_js__WEBPACK_IMPORTED_MODULE_5__["AES"].encrypt(JSON.stringify(data), secret, {
        keySize: 128 / 8,
        iv: secret,
        mode: crypto_js__WEBPACK_IMPORTED_MODULE_5__["mode"].CBC,
        padding: crypto_js__WEBPACK_IMPORTED_MODULE_5__["pad"].Pkcs7
    }).toString();
}
function decrypt(data) {
    let secret = (src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].SecretKey || "");
    return JSON.parse(crypto_js__WEBPACK_IMPORTED_MODULE_5__["enc"].Utf8.stringify(crypto_js__WEBPACK_IMPORTED_MODULE_5__["AES"].decrypt(data, secret, {
        keySize: 128 / 8,
        iv: secret,
        mode: crypto_js__WEBPACK_IMPORTED_MODULE_5__["mode"].CBC,
        padding: crypto_js__WEBPACK_IMPORTED_MODULE_5__["pad"].Pkcs7
    })));
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _login_login_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./login/login.component */ "./src/app/login/login.component.ts");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./home/home.component */ "./src/app/home/home.component.ts");
/* harmony import */ var _forgot_password_forgot_password_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./forgot-password/forgot-password.component */ "./src/app/forgot-password/forgot-password.component.ts");
/* harmony import */ var _change_password_change_password_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./change-password/change-password.component */ "./src/app/change-password/change-password.component.ts");
/* harmony import */ var _reset_password_reset_password_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./reset-password/reset-password.component */ "./src/app/reset-password/reset-password.component.ts");
/* harmony import */ var _podcast_topic_podcast_topic_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./podcast-topic/podcast-topic.component */ "./src/app/podcast-topic/podcast-topic.component.ts");
/* harmony import */ var _podcast_podcast_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./podcast/podcast.component */ "./src/app/podcast/podcast.component.ts");
/* harmony import */ var _gaurd_auth_guard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./_gaurd/auth.guard */ "./src/app/_gaurd/auth.guard.ts");
/* harmony import */ var _privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./privacy-policy/privacy-policy.component */ "./src/app/privacy-policy/privacy-policy.component.ts");
/* harmony import */ var _landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./landing-page/landing-page.component */ "./src/app/landing-page/landing-page.component.ts");













const routes = [
    //{ path: '', component: LoginComponent, pathMatch: 'full' },
    { path: '', component: _landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_12__["LandingPageComponent"], pathMatch: 'full' },
    { path: 'Login', component: _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"] },
    { path: 'Dashboard', component: _home_home_component__WEBPACK_IMPORTED_MODULE_4__["HomeComponent"], canActivate: [_gaurd_auth_guard__WEBPACK_IMPORTED_MODULE_10__["AuthGuard"]] },
    { path: 'ForgotPassword', component: _forgot_password_forgot_password_component__WEBPACK_IMPORTED_MODULE_5__["ForgotPasswordComponent"] },
    { path: 'ChangePassword', component: _change_password_change_password_component__WEBPACK_IMPORTED_MODULE_6__["ChangePasswordComponent"], canActivate: [_gaurd_auth_guard__WEBPACK_IMPORTED_MODULE_10__["AuthGuard"]] },
    { path: 'ResetPassword', component: _reset_password_reset_password_component__WEBPACK_IMPORTED_MODULE_7__["ResetPasswordComponent"] },
    { path: 'PodcastTopic', component: _podcast_topic_podcast_topic_component__WEBPACK_IMPORTED_MODULE_8__["PodcastTopicComponent"], canActivate: [_gaurd_auth_guard__WEBPACK_IMPORTED_MODULE_10__["AuthGuard"]] },
    { path: 'Podcast', component: _podcast_podcast_component__WEBPACK_IMPORTED_MODULE_9__["PodcastComponent"], canActivate: [_gaurd_auth_guard__WEBPACK_IMPORTED_MODULE_10__["AuthGuard"]] },
    { path: 'PrivacyPolicy', component: _privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_11__["PrivacyPolicyComponent"] },
    { path: '**', redirectTo: '' },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, { preloadingStrategy: _angular_router__WEBPACK_IMPORTED_MODULE_2__["PreloadAllModules"] })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./service/user.service */ "./src/app/service/user.service.ts");
/* harmony import */ var bn_ng_idle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! bn-ng-idle */ "./node_modules/bn-ng-idle/fesm2015/bn-ng-idle.js");





let AppComponent = class AppComponent {
    constructor(router, authenticationService, bnIdle) {
        this.router = router;
        this.authenticationService = authenticationService;
        this.bnIdle = bnIdle;
        this.title = 'SoilHealth';
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    }
    ngOnInit() {
        this.bnIdle.startWatching(1200).subscribe((res) => {
            if (res) {
                console.log("Admin session expired");
                localStorage.removeItem("currentUser");
                this.router.navigate(['/']);
            }
        });
    }
    logout() {
        //this.authenticationService.logout();
        this.router.navigate(['/']);
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"] },
    { type: bn_ng_idle__WEBPACK_IMPORTED_MODULE_4__["BnNgIdleService"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _login_login_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./login/login.component */ "./src/app/login/login.component.ts");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./home/home.component */ "./src/app/home/home.component.ts");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _nav_menu_nav_menu_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./nav-menu/nav-menu.component */ "./src/app/nav-menu/nav-menu.component.ts");
/* harmony import */ var _change_password_change_password_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./change-password/change-password.component */ "./src/app/change-password/change-password.component.ts");
/* harmony import */ var _forgot_password_forgot_password_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./forgot-password/forgot-password.component */ "./src/app/forgot-password/forgot-password.component.ts");
/* harmony import */ var _podcast_podcast_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./podcast/podcast.component */ "./src/app/podcast/podcast.component.ts");
/* harmony import */ var _podcast_topic_podcast_topic_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./podcast-topic/podcast-topic.component */ "./src/app/podcast-topic/podcast-topic.component.ts");
/* harmony import */ var _reset_password_reset_password_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./reset-password/reset-password.component */ "./src/app/reset-password/reset-password.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/cdk/drag-drop */ "./node_modules/@angular/cdk/esm2015/drag-drop.js");
/* harmony import */ var _helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./_helpers/jwt.interceptor */ "./src/app/_helpers/jwt.interceptor.ts");
/* harmony import */ var _helpers_error_interceptor__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./_helpers/error.interceptor */ "./src/app/_helpers/error.interceptor.ts");
/* harmony import */ var ngx_image_cropper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ngx-image-cropper */ "./node_modules/ngx-image-cropper/fesm2015/ngx-image-cropper.js");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var ngx_bootstrap__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ngx-bootstrap */ "./node_modules/ngx-bootstrap/esm5/ngx-bootstrap.js");
/* harmony import */ var bn_ng_idle__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! bn-ng-idle */ "./node_modules/bn-ng-idle/fesm2015/bn-ng-idle.js");
/* harmony import */ var _privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./privacy-policy/privacy-policy.component */ "./src/app/privacy-policy/privacy-policy.component.ts");
/* harmony import */ var _landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./landing-page/landing-page.component */ "./src/app/landing-page/landing-page.component.ts");






















//import { ModalModule } from 'ngx-bootstrap/modal/public_api';






let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _login_login_component__WEBPACK_IMPORTED_MODULE_5__["LoginComponent"],
            _home_home_component__WEBPACK_IMPORTED_MODULE_6__["HomeComponent"],
            _nav_menu_nav_menu_component__WEBPACK_IMPORTED_MODULE_12__["NavMenuComponent"],
            _change_password_change_password_component__WEBPACK_IMPORTED_MODULE_13__["ChangePasswordComponent"],
            _forgot_password_forgot_password_component__WEBPACK_IMPORTED_MODULE_14__["ForgotPasswordComponent"],
            _podcast_podcast_component__WEBPACK_IMPORTED_MODULE_15__["PodcastComponent"],
            _podcast_topic_podcast_topic_component__WEBPACK_IMPORTED_MODULE_16__["PodcastTopicComponent"],
            _reset_password_reset_password_component__WEBPACK_IMPORTED_MODULE_17__["ResetPasswordComponent"],
            _privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_26__["PrivacyPolicyComponent"],
            _landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_27__["LandingPageComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"].withServerTransition({ appId: 'ng-cli-universal' }),
            _angular_common_http__WEBPACK_IMPORTED_MODULE_9__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_8__["FormsModule"],
            ngx_image_cropper__WEBPACK_IMPORTED_MODULE_22__["ImageCropperModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__["BrowserAnimationsModule"],
            ngx_spinner__WEBPACK_IMPORTED_MODULE_7__["NgxSpinnerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_18__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_18__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_18__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_18__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_18__["MatInputModule"],
            _angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_19__["DragDropModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_18__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_18__["MatSelectModule"],
            ngx_bootstrap__WEBPACK_IMPORTED_MODULE_24__["ModalModule"].forRoot(),
            ngx_toastr__WEBPACK_IMPORTED_MODULE_10__["ToastrModule"].forRoot({
                timeOut: 10000,
                positionClass: 'toast-top-center',
                preventDuplicates: true,
                closeButton: true
            }),
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
        ],
        providers: [{ provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_9__["HTTP_INTERCEPTORS"], useClass: _helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_20__["JwtInterceptor"], multi: true },
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_9__["HTTP_INTERCEPTORS"], useClass: _helpers_error_interceptor__WEBPACK_IMPORTED_MODULE_21__["ErrorInterceptor"], multi: true },
            ngx_cookie_service__WEBPACK_IMPORTED_MODULE_23__["CookieService"], bn_ng_idle__WEBPACK_IMPORTED_MODULE_25__["BnNgIdleService"]],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/change-password/change-password.component.css":
/*!***************************************************************!*\
  !*** ./src/app/change-password/change-password.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NoYW5nZS1wYXNzd29yZC9jaGFuZ2UtcGFzc3dvcmQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/change-password/change-password.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/change-password/change-password.component.ts ***!
  \**************************************************************/
/*! exports provided: ChangePasswordComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangePasswordComponent", function() { return ChangePasswordComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");






let ChangePasswordComponent = class ChangePasswordComponent {
    constructor(route, router, spinner, service, toastr) {
        this.route = route;
        this.router = router;
        this.spinner = spinner;
        this.service = service;
        this.toastr = toastr;
        this.model = {};
        this.data = {};
    }
    ngOnInit() {
        this.data = JSON.parse(localStorage.getItem('currentUser'));
    }
    onSubmit(f) {
        console.log(this.data.token);
        let reset = {
            "password": this.model.Password,
            "token": this.data.token
        };
        this.spinner.show();
        if (this.model.Password == this.model.ConfirmPassword) {
            this.service.changePassword(reset)
                .subscribe(data => {
                this.spinner.hide();
                if (data.responseCode == 200) {
                    f.resetForm();
                    this.toastr.success(data.responseData);
                }
                else {
                    this.spinner.hide();
                    this.toastr.error(data.responseData);
                }
            }, error => {
                // this.error = error;
            });
        }
        else {
            this.spinner.hide();
            this.toastr.info('confirm password must be same as password');
        }
    }
};
ChangePasswordComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: ngx_spinner__WEBPACK_IMPORTED_MODULE_3__["NgxSpinnerService"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] }
];
ChangePasswordComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-change-password',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./change-password.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/change-password/change-password.component.html")).default,
        providers: [_service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"], ngx_spinner__WEBPACK_IMPORTED_MODULE_3__["NgxSpinnerService"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./change-password.component.css */ "./src/app/change-password/change-password.component.css")).default]
    })
], ChangePasswordComponent);



/***/ }),

/***/ "./src/app/forgot-password/forgot-password.component.css":
/*!***************************************************************!*\
  !*** ./src/app/forgot-password/forgot-password.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2ZvcmdvdC1wYXNzd29yZC9mb3Jnb3QtcGFzc3dvcmQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/forgot-password/forgot-password.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/forgot-password/forgot-password.component.ts ***!
  \**************************************************************/
/*! exports provided: ForgotPasswordComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ForgotPasswordComponent", function() { return ForgotPasswordComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");






let ForgotPasswordComponent = class ForgotPasswordComponent {
    constructor(route, router, spinner, service, toastr) {
        this.route = route;
        this.router = router;
        this.spinner = spinner;
        this.service = service;
        this.toastr = toastr;
        this.model = {};
    }
    ngOnInit() {
    }
    onSubmit() {
        this.spinner.show();
        this.service.forgotPassword(this.model)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.toastr.success(data.responseData);
                setTimeout(() => {
                    this.router.navigateByUrl('/');
                }, 5000);
            }
            else {
                this.toastr.error(data.responseData);
            }
        }, error => {
            // this.error = error;
        });
    }
};
ForgotPasswordComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: ngx_spinner__WEBPACK_IMPORTED_MODULE_3__["NgxSpinnerService"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] }
];
ForgotPasswordComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-forgot-password',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./forgot-password.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/forgot-password/forgot-password.component.html")).default,
        providers: [_service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"], ngx_spinner__WEBPACK_IMPORTED_MODULE_3__["NgxSpinnerService"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./forgot-password.component.css */ "./src/app/forgot-password/forgot-password.component.css")).default]
    })
], ForgotPasswordComponent);



/***/ }),

/***/ "./src/app/home/home.component.css":
/*!*****************************************!*\
  !*** ./src/app/home/home.component.css ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2hvbWUvaG9tZS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/home/home.component.ts":
/*!****************************************!*\
  !*** ./src/app/home/home.component.ts ***!
  \****************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");





let HomeComponent = class HomeComponent {
    constructor(spinner, service, toastr) {
        this.spinner = spinner;
        this.service = service;
        this.toastr = toastr;
        this.PDTopic = 0;
        this.PD = 0;
    }
    ngOnInit() {
        this.spinner.show();
        this.service.getDashboard()
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                console.log(data.responseData);
                this.PD = data.responseData.podcastCount;
                this.PDTopic = data.responseData.podcastTopicCount;
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData);
            }
        }, error => {
            // this.error = error;
        });
    }
};
HomeComponent.ctorParameters = () => [
    { type: ngx_spinner__WEBPACK_IMPORTED_MODULE_2__["NgxSpinnerService"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_4__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_3__["ToastrService"] }
];
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html")).default,
        providers: [_service_user_service__WEBPACK_IMPORTED_MODULE_4__["UserService"], ngx_spinner__WEBPACK_IMPORTED_MODULE_2__["NgxSpinnerService"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.css */ "./src/app/home/home.component.css")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/landing-page/landing-page.component.css":
/*!*********************************************************!*\
  !*** ./src/app/landing-page/landing-page.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("* {\r\n  margin: auto;\r\n  padding: 0px;\r\n  box-sizing: border-box;\r\n}\r\nbody {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  padding: 0px;\r\n}\r\n.container {\r\n  width: 1100px;\r\n  max-width: 100%;\r\n}\r\n.container img {\r\n    max-width: 100%;\r\n    margin-bottom: 0px;\r\n  }\r\n.container h1 {\r\n    margin: 20px auto;\r\n    font-size: 1.5rem;\r\n    line-height: 30px;\r\n  }\r\n.container p {\r\n    line-height: 27px;\r\n    font-size: 14px;\r\n    margin-top: 5px;\r\n  }\r\n.col-4 {\r\n  width: 33%;\r\n  float: left;\r\n  padding: 20px;\r\n  margin-top: 30px;\r\n}\r\n.col-half p {\r\n  margin: 0px;\r\n}\r\n.LoginBtn {\r\n  color: #ffffff;\r\n  background-color: #28a745;\r\n  border-color: #28a745;\r\n  box-shadow: none;\r\n  padding: 0.475rem 1.55rem;\r\n  font-size: 1.3rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n}\r\n.LoginBtn:hover {\r\n    color: #ffffff;\r\n    background-color: #218838;\r\n    border-color: #1e7e34;\r\n  }\r\n.innerContainer {\r\n  width: 1100px;\r\n  max-width: 96%;\r\n  display: inline-block;\r\n  background: #fff;\r\n  border-radius: 20px;\r\n  padding-bottom: 30px;\r\n}\r\n.text-right {\r\n  text-align: right;\r\n}\r\n.text-center {\r\n  text-align: center;\r\n}\r\n.homepageOuter {\r\n  background: #0b8042;\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  display: flex;\r\n}\r\n.InnerContentSec {\r\n  width: 100%;\r\n  display: inline-block;\r\n  padding: 20px;\r\n}\r\n@media screen and (max-width:767px) {\r\n  .m-col-6 {\r\n    width: 50%;\r\n  }\r\n\r\n  .m-loginBtnFull {\r\n    width: 100%;\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .LoginBtn {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/landing-page/landing-page.component.ts":
/*!********************************************************!*\
  !*** ./src/app/landing-page/landing-page.component.ts ***!
  \********************************************************/
/*! exports provided: LandingPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LandingPageComponent", function() { return LandingPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let LandingPageComponent = class LandingPageComponent {
    constructor() { }
    ngOnInit() {
    }
    onNavigate() {
        /*window.open("https://www.soilhealth.com/", "_blank");*/
        window.open('/PrivacyPolicy', '_blank').focus();
    }
};
LandingPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-landing-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./landing-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/landing-page/landing-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./landing-page.component.css */ "./src/app/landing-page/landing-page.component.css")).default]
    })
], LandingPageComponent);



/***/ }),

/***/ "./src/app/login/login.component.css":
/*!*******************************************!*\
  !*** ./src/app/login/login.component.css ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/login/login.component.ts":
/*!******************************************!*\
  !*** ./src/app/login/login.component.ts ***!
  \******************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var _helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../_helpers/jwt.interceptor */ "./src/app/_helpers/jwt.interceptor.ts");








let LoginComponent = class LoginComponent {
    constructor(route, router, toastr, service, spinner, cookieService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.service = service;
        this.spinner = spinner;
        this.cookieService = cookieService;
        this.cookieValue = 'UNKNOWN';
        this.model = {};
    }
    ngOnInit() {
        this.cookieExists = this.cookieService.check('Email');
        if (localStorage.getItem('currentUser') != null) {
            this.router.navigate(['/Dashboard']);
        }
        else {
            this.router.navigate(['/Login']);
            if (this.cookieExists) {
                this.model.Email = Object(_helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_7__["decrypt"])(this.cookieService.get('Email'));
                this.model.Password = Object(_helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_7__["decrypt"])(this.cookieService.get('Password'));
                this.model.remember = this.cookieService.get('Remember');
            }
        }
    }
    onSubmit(f) {
        this.spinner.show();
        if (this.model.remember) {
            this.cookieService.set('Email', Object(_helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_7__["encrypt"])(this.model.Email));
            this.cookieService.set('Password', Object(_helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_7__["encrypt"])(this.model.Password));
            this.cookieService.set('Remember', Object(_helpers_jwt_interceptor__WEBPACK_IMPORTED_MODULE_7__["encrypt"])(this.model.remember));
            // this.cookieValue = this.cookieService.get('Test');
        }
        else {
            this.cookieService.deleteAll();
        }
        this.service.login(this.model)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.router.navigate(['/Dashboard']);
            }
            else {
                this.toastr.error(data.responseData);
            }
        }, error => {
            this.spinner.hide();
            // this.error = error;
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_3__["ToastrService"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: ngx_spinner__WEBPACK_IMPORTED_MODULE_4__["NgxSpinnerService"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_6__["CookieService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html")).default,
        providers: [_service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"], ngx_spinner__WEBPACK_IMPORTED_MODULE_4__["NgxSpinnerService"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/login/login.component.css")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/nav-menu/nav-menu.component.css":
/*!*************************************************!*\
  !*** ./src/app/nav-menu/nav-menu.component.css ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL25hdi1tZW51L25hdi1tZW51LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/nav-menu/nav-menu.component.ts":
/*!************************************************!*\
  !*** ./src/app/nav-menu/nav-menu.component.ts ***!
  \************************************************/
/*! exports provided: NavMenuComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavMenuComponent", function() { return NavMenuComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");




let NavMenuComponent = class NavMenuComponent {
    constructor(route, router, service) {
        this.route = route;
        this.router = router;
        this.service = service;
        this.isExpanded = false;
    }
    collapse() {
        this.isExpanded = false;
    }
    toggle() {
        this.isExpanded = !this.isExpanded;
    }
    Logout() {
        this.service.logout();
        this.router.navigate(['/']);
    }
    ngOnInit() {
    }
};
NavMenuComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"] }
];
NavMenuComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-nav-menu',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./nav-menu.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/nav-menu/nav-menu.component.html")).default,
        providers: [_service_user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./nav-menu.component.css */ "./src/app/nav-menu/nav-menu.component.css")).default]
    })
], NavMenuComponent);



/***/ }),

/***/ "./src/app/podcast-topic/podcast-topic.component.css":
/*!***********************************************************!*\
  !*** ./src/app/podcast-topic/podcast-topic.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/** No CSS for this example */\r\nmat-icon {\r\n  cursor: pointer;\r\n}\r\n.mat-option-text {\r\n  color:#ff0000;\r\n}\r\n.cdk-drag-placeholder {\r\n  background: #bfc07d;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcG9kY2FzdC10b3BpYy9wb2RjYXN0LXRvcGljLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNkJBQTZCO0FBQzdCO0VBQ0UsZUFBZTtBQUNqQjtBQUVBO0VBQ0UsYUFBYTtBQUNmO0FBQ0E7RUFDRSxtQkFBbUI7QUFDckIiLCJmaWxlIjoic3JjL2FwcC9wb2RjYXN0LXRvcGljL3BvZGNhc3QtdG9waWMuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBObyBDU1MgZm9yIHRoaXMgZXhhbXBsZSAqL1xyXG5tYXQtaWNvbiB7XHJcbiAgY3Vyc29yOiBwb2ludGVyO1xyXG59XHJcblxyXG4ubWF0LW9wdGlvbi10ZXh0IHtcclxuICBjb2xvcjojZmYwMDAwO1xyXG59XHJcbi5jZGstZHJhZy1wbGFjZWhvbGRlciB7XHJcbiAgYmFja2dyb3VuZDogI2JmYzA3ZDtcclxufVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/podcast-topic/podcast-topic.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/podcast-topic/podcast-topic.component.ts ***!
  \**********************************************************/
/*! exports provided: PodcastTopicComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PodcastTopicComponent", function() { return PodcastTopicComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/drag-drop */ "./node_modules/@angular/cdk/esm2015/drag-drop.js");
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash.clonedeep */ "./node_modules/lodash.clonedeep/index.js");
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ngx-bootstrap/modal */ "./node_modules/ngx-bootstrap/modal/fesm2015/ngx-bootstrap-modal.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");











const ELEMENT_DATA = [];
let PodcastTopicComponent = class PodcastTopicComponent {
    constructor(route, router, spinner, service, toastr, modalService) {
        this.route = route;
        this.router = router;
        this.spinner = spinner;
        this.service = service;
        this.toastr = toastr;
        this.modalService = modalService;
        this.model = {};
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.ViewImage = '';
        this.id = 0;
        this.title = '';
        this.Htmloption = 'S';
        this.displayedColumns = ['DisplayOrder', 'Topic', 'Thumbnail', 'Action'];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_6__["MatTableDataSource"](ELEMENT_DATA);
    }
    ngOnInit() {
        this.ELEMENT_DATA2 = [];
        this.getPodcastTopicList();
        console.log(this.ELEMENT_DATA);
        this.dataSource2 = new _angular_material_table__WEBPACK_IMPORTED_MODULE_6__["MatTableDataSource"](this.ELEMENT_DATA2);
        this.dataSource.paginator = this.paginator;
        this.model.Id = 0;
    }
    drop(event) {
        if (event.previousContainer === event.container) {
            Object(_angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_7__["moveItemInArray"])(event.container.data, event.previousIndex, event.currentIndex);
        }
        else {
            Object(_angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_7__["transferArrayItem"])(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
        // updates moved data and table, but not dynamic if more dropzones
        this.dataSource.data = this.dataSource && this.dataSource.data ? lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8___default()(this.dataSource.data) : [];
        this.dataSource2.data = this.dataSource2 && this.dataSource2.data ? lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8___default()(this.dataSource2.data) : [];
        if (this.dataSource && this.dataSource.data) {
            this.dataSource.data.forEach((value, key) => {
                this.dataSource.data[key].displayOrder = key + 1;
            });
        }
        console.log('this.dataSource.data', this.dataSource.data);
        this.updateDisplayorder(this.dataSource.data);
    }
    updateDisplayorder(lst) {
        console.log('updateDisplayorder', lst);
        this.service.updateDisplayOrder(lst)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.getPodcastTopicList();
                //this.ELEMENT_DATA = data.responseData;
                //console.log('this.ELEMENT_DATA', this.ELEMENT_DATA);
                //this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
    }
    applyFilter(filterValue) {
        //this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    fileChangeEvent(event) {
        var file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];
        var pattern = /image-*/;
        if (!file.type.match(pattern)) {
            this.toastr.error("Invalid Format", '');
            file = "";
            return;
        }
        else {
            this.imageChangedEvent = event;
        }
    }
    imageCropped(event) {
        this.croppedImage = event.base64;
        this.model.Thumbnail = this.croppedImage;
    }
    imageLoaded() {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }
    getPodcastTopicList() {
        this.spinner.show();
        this.service.getPodcastTopicList()
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.ELEMENT_DATA = data.responseData;
                console.log('this.ELEMENT_DATA', this.ELEMENT_DATA);
                this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_6__["MatTableDataSource"](this.ELEMENT_DATA);
                this.dataSource.paginator = this.paginator;
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
    }
    onSubmit(f) {
        this.spinner.show();
        console.log(this.model);
        if (this.model.Id == undefined)
            this.model.Id = 0;
        if (this.model.Id == 0) {
            if (this.model.Thumbnail != null) {
                this.service.createPodcastTopic(this.model)
                    .subscribe(data => {
                    this.spinner.hide();
                    if (data.responseCode == 200) {
                        this.toastr.success(data.responseData);
                        this.getPodcastTopicList();
                        this.reset(f);
                        this.model = {};
                    }
                    else {
                        this.spinner.hide();
                        this.toastr.error(data.responseData, '');
                        this.reset(f);
                        this.model = {};
                    }
                }, error => {
                    // this.error = error;
                    this.spinner.hide();
                });
            }
            else {
                this.spinner.hide();
                this.toastr.error("Image cannot be blank");
            }
        }
        else {
            this.service.updatePodcastTopic(this.model)
                .subscribe(data => {
                this.spinner.hide();
                if (data.responseCode == 200) {
                    this.toastr.success(data.responseData);
                    this.getPodcastTopicList();
                    this.reset(f);
                    this.model = {};
                }
                else {
                    this.spinner.hide();
                    this.toastr.error(data.responseData, '');
                    this.reset(f);
                    this.model = {};
                }
            }, error => {
                // this.error = error;
                this.spinner.hide();
            });
        }
    }
    openModal(template, rowData) {
        this.modalRef = this.modalService.show(template);
        this.ViewImage = " Images/" + rowData.thumbnail;
        this.title = rowData.topicTitle;
    }
    EditPodcastTopic(id) {
        this.service.getPodcastTopicByID(id)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                console.log(data);
                this.model.Id = data.responseData.id;
                this.model.DisplayOrder = data.responseData.displayOrder;
                this.model.TopicTitle = data.responseData.topicTitle;
                this.croppedImage = "Images/" + data.responseData.thumbnail;
                this.model.Thumbnail = data.responseData.thumbnail;
                this.model.AddedOnUtc = data.responseData.addedOnUtc;
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
    }
    openDeleteModal(template, id) {
        this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
        this.id = id;
    }
    confirm(id) {
        //this.message = 'Confirmed!';
        this.service.deletePodcastTopic(id)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.toastr.success(data.responseData);
                this.getPodcastTopicList();
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
        this.modalRef.hide();
    }
    decline() {
        // this.message = 'Declined!';
        this.modalRef.hide();
    }
    reset(f) {
        f.resetForm();
        setTimeout(() => {
            this.model.topicId = "";
            this.myInputVariable.nativeElement.value = "";
            this.croppedImage = '';
            this.imageChangedEvent = '';
        });
    }
};
PodcastTopicComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: ngx_spinner__WEBPACK_IMPORTED_MODULE_2__["NgxSpinnerService"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_10__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] },
    { type: ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_9__["BsModalService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('table1', { static: false })
], PodcastTopicComponent.prototype, "table1", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('table2', { static: false })
], PodcastTopicComponent.prototype, "table2", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('list1', { static: false })
], PodcastTopicComponent.prototype, "list1", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('myInput', { static: false })
], PodcastTopicComponent.prototype, "myInputVariable", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__["MatPaginator"], { static: false })
], PodcastTopicComponent.prototype, "paginator", void 0);
PodcastTopicComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-podcast-topic',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./podcast-topic.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/podcast-topic/podcast-topic.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./podcast-topic.component.css */ "./src/app/podcast-topic/podcast-topic.component.css")).default]
    })
], PodcastTopicComponent);



/***/ }),

/***/ "./src/app/podcast/podcast.component.css":
/*!***********************************************!*\
  !*** ./src/app/podcast/podcast.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/** No CSS for this example */\r\nmat-icon {\r\n  cursor: pointer;\r\n}\r\n.cdk-drag-placeholder {\r\n  background: #bfc07d;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcG9kY2FzdC9wb2RjYXN0LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNkJBQTZCO0FBQzdCO0VBQ0UsZUFBZTtBQUNqQjtBQUNBO0VBQ0UsbUJBQW1CO0FBQ3JCIiwiZmlsZSI6InNyYy9hcHAvcG9kY2FzdC9wb2RjYXN0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvKiogTm8gQ1NTIGZvciB0aGlzIGV4YW1wbGUgKi9cclxubWF0LWljb24ge1xyXG4gIGN1cnNvcjogcG9pbnRlcjtcclxufVxyXG4uY2RrLWRyYWctcGxhY2Vob2xkZXIge1xyXG4gIGJhY2tncm91bmQ6ICNiZmMwN2Q7XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/podcast/podcast.component.ts":
/*!**********************************************!*\
  !*** ./src/app/podcast/podcast.component.ts ***!
  \**********************************************/
/*! exports provided: PodcastComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PodcastComponent", function() { return PodcastComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/drag-drop */ "./node_modules/@angular/cdk/esm2015/drag-drop.js");
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash.clonedeep */ "./node_modules/lodash.clonedeep/index.js");
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ngx-bootstrap/modal */ "./node_modules/ngx-bootstrap/modal/fesm2015/ngx-bootstrap-modal.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");











const Podcast_DATA = [];
let PodcastComponent = class PodcastComponent {
    constructor(route, router, spinner, service, toastr, modalService) {
        this.route = route;
        this.router = router;
        this.spinner = spinner;
        this.service = service;
        this.toastr = toastr;
        this.modalService = modalService;
        this.model = {};
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.ViewImage = '';
        this.title = '';
        this.id = 0;
        this.Htmloption = 'S';
        this.displayedColumns = ['DisplayOrder', 'Topic', 'File', 'Action'];
        this.Podcast_DATA = [];
        this.Podcast_DATA2 = [];
        this.PodcastdataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_6__["MatTableDataSource"](Podcast_DATA);
        this.foods = [
            { value: 'steak-0', viewValue: 'Steak' },
            { value: 'pizza-1', viewValue: 'Pizza' },
            { value: 'tacos-2', viewValue: 'Tacos' }
        ];
    }
    ngOnInit() {
        this.model.topicId = "";
        //  this.PodcastdataSource = [];
        //this.Podcast_DATA = [
        //  { "displayOrder": 7, "topicTitle": 'Nitrogen', "file": null, "Action": 'N' },
        //  { "displayOrder": 8, "topicTitle": 'Oxygen', "file": null, "Action": 'O' },
        //  { "displayOrder": 9, "topicTitle": 'Fluorine', "file": null, "Action": 'F' },
        //  { "displayOrder": 10, "topicTitle": 'Neon', "file": null, "Action": 'Ne' },
        //];
        //this.PodcastdataSource = this.Podcast_DATA;
        /*temp*/
        //this.spinner.show();
        //this.service.getPodcastList()
        //  .subscribe(
        //    data => {
        //      this.spinner.hide();
        //      if (data.responseCode == 200) {
        //        console.log(data.responseData);
        //        this.Podcast_DATA = data.responseData;
        //        debugger;
        //        //this.Podcast_DATA = [
        //        //  { displayOrder: 7, topicTitle: 'Nitrogen', file: null, Action: 'N' },
        //        //  { displayOrder: 8, topicTitle: 'Oxygen', file: null, Action: 'O' },
        //        //  { displayOrder: 9, topicTitle: 'Fluorine', file: null, Action: 'F' },
        //        //  { displayOrder: 10, topicTitle: 'Neon', file: null, Action: 'Ne' },
        //        //];
        //        this.PodcastdataSource = this.Podcast_DATA;
        //        console.log('this.Podcast_DATA', this.Podcast_DATA);
        //        // this.PodcastdataSource = new MatTableDataSource(this.Podcast_DATA);
        //        console.log(this.PodcastdataSource);
        //      }
        //      else {
        //        this.spinner.hide();
        //        this.toastr.error(data.responseData);
        //      }
        //    },
        //    error => {
        //      // this.error = error;
        //    });
        /*temp end*/
        //this.dataSource2 = new MatTableDataSource(this.Podcast_DATA2);
        this.getPodcastList();
        //console.log(this.Podcast_DATA);
        // this.dataSource2 = new MatTableDataSource(this.Podcast_DATA2);
        this.model.Id = 0;
        this.getTopicList();
    }
    SetDragDropData(data) {
        this.PodcastdataSource.data = data;
    }
    drop(event) {
        console.log(event.item.data);
        const prevIndex = this.PodcastdataSource.data.findIndex((d) => d === event.item.data);
        Object(_angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_7__["moveItemInArray"])(this.PodcastdataSource.data, prevIndex, event.currentIndex);
        this.table1.renderRows();
        //if (event.previousContainer === event.container) {
        //  moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        //  this.table1.renderRows();
        //} else {
        //  transferArrayItem(event.previousContainer.data,
        //    event.container.data,
        //    event.previousIndex,
        //    event.currentIndex);
        //}
        // updates moved data and table, but not dynamic if more dropzones
        this.PodcastdataSource.data = this.PodcastdataSource.data ? lodash_clonedeep__WEBPACK_IMPORTED_MODULE_8___default()(this.PodcastdataSource.data) : [];
        //  this.dataSource2.data = this.dataSource2 && this.dataSource2.data ? clonedeep(this.dataSource2.data) : [];
        if (this.PodcastdataSource) {
            this.PodcastdataSource.data.forEach((value, key) => {
                this.PodcastdataSource.data[key].displayOrder = key + 1;
            });
        }
        console.log('this.dataSource.data', this.PodcastdataSource);
        // this.updateDisplayorder(_.cloneDeep(this.PodcastdataSource.data);
        this.updateDisplayorder(this.PodcastdataSource.data);
    }
    getPodcastList() {
        this.spinner.show();
        this.service.getPodcastList()
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                //console.log(data.responseData);
                this.Podcast_DATA = data.responseData;
                //this.SetDragDropData(data.responseData);
                //this.Podcast_DATA = [
                //  { displayOrder: 7, topicTitle: 'Nitrogen', file: null, Action: 'N' },
                //  { displayOrder: 8, topicTitle: 'Oxygen', file: null, Action: 'O' },
                //  { displayOrder: 9, topicTitle: 'Fluorine', file: null, Action: 'F' },
                //  { displayOrder: 10, topicTitle: 'Neon', file: null, Action: 'Ne' },
                //];
                this.PodcastdataSource.data = this.Podcast_DATA;
                this.PodcastdataSource.paginator = this.paginator;
                // this.PodcastdataSource.paginator = this.paginator;
                this.table1.renderRows();
                //console.log('this.Podcast_DATA', this.Podcast_DATA);
                // this.PodcastdataSource = new MatTableDataSource(this.Podcast_DATA);
                // console.log(this.PodcastdataSource);
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
    }
    updateDisplayorder(lst) {
        console.log('updateDisplayorder', lst);
        this.service.updatePodcastDisplayOrder(lst)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.getPodcastList();
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
    }
    applyFilter(filterValue) {
        console.log(filterValue);
        if (filterValue == "Select All") {
            this.PodcastdataSource.filter = "";
            this.renderedRows = undefined;
            // this.PodcastdataSource.data=[];
            // this.getPodcastList();
        }
        else {
            this.PodcastdataSource.filter = filterValue.trim().toLowerCase();
            setTimeout(() => {
                try {
                    this.renderedRows = document.getElementsByClassName("mat-row").length;
                }
                catch (e) {
                }
            });
        }
    }
    fileChangeEvent(e) {
        var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
        var pattern = /audio-*/;
        var reader = new FileReader();
        if (!file.type.match(pattern)) {
            this.toastr.error("Invalid Format", '');
            file = "";
            return;
        }
        if (file.siz > 100000000) {
            this.toastr.error("File is too big. Maximum 100mb file can be allowed.", '');
            file = "";
            return;
        }
        this.model.files = file;
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(file);
    }
    _handleReaderLoaded(e) {
        let reader = e.target;
        this.model.file = ""; // reader.result;
    }
    getTopicList() {
        this.service.getPodcastTopicList()
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.topiclist = data.responseData;
                console.log('this.Podcast_DATA', this.topiclist);
                //this.dataSource = new MatTableDataSource(this.Podcast_DATA);
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
    }
    onSubmit(f) {
        this.spinner.show();
        if (this.model.Id == undefined)
            this.model.Id = 0;
        if (this.model.Id == 0) {
            if (this.model.file != null) {
                this.model.topicId = parseInt(this.model.topicId);
                // this.model.Id = parseInt(this.model.topicId);
                if (this.model.Id == 0)
                    this.model.Id = "";
                var fd = new FormData();
                fd.append("topicId", this.model.topicId);
                fd.append("files", this.model.files);
                fd.append("file", "");
                fd.append("description", this.model.Description);
                this.service.createPodcast(fd)
                    .subscribe(data => {
                    this.spinner.hide();
                    if (data.responseCode == 200) {
                        this.toastr.success(data.responseData);
                        this.getPodcastList();
                        this.reset(f);
                        this.model = {};
                    }
                    else {
                        this.spinner.hide();
                        this.reset(f);
                        this.toastr.error(data.responseData, '');
                    }
                }, error => {
                    this.spinner.hide();
                    // this.error = error;
                });
            }
            else {
                this.toastr.error("Audio File required", '');
                this.spinner.hide();
            }
        }
        else {
            this.model.Id = this.model.Id.toString();
            var fd = new FormData();
            if (this.model.file == "") {
                fd.append("files", this.model.files);
                fd.append("file", "");
            }
            else {
                fd.append("files", null);
                fd.append("file", this.model.file);
            }
            fd.append("Id", this.model.Id);
            fd.append("topicId", this.model.topicId);
            fd.append("description", this.model.Description);
            this.service.updatePodcast(fd)
                .subscribe(data => {
                this.spinner.hide();
                if (data.responseCode == 200) {
                    this.toastr.success(data.responseData);
                    this.getPodcastList();
                    this.reset(f);
                    this.model = {};
                }
                else {
                    this.spinner.hide();
                    this.reset(f);
                    this.toastr.error(data.responseData, '');
                }
            }, error => {
                // this.error = error;
                this.spinner.hide();
            });
        }
    }
    EditPodcastTopic(id) {
        this.service.getPodcastByID(id)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                console.log(data);
                this.model.Id = data.responseData.id;
                this.model.DisplayOrder = data.responseData.displayOrder;
                this.model.topicId = data.responseData.topicId;
                //this.croppedImage = "Audio/" + data.responseData.file;
                this.model.file = data.responseData.file;
                this.model.Description = data.responseData.description;
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData);
            }
        }, error => {
            // this.error = error;
            this.spinner.hide();
        });
    }
    openDeleteModal(template, id) {
        this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
        this.id = id;
    }
    confirm(id) {
        //this.message = 'Confirmed!';
        this.service.deletePodcast(id)
            .subscribe(data => {
            this.spinner.hide();
            if (data.responseCode == 200) {
                this.toastr.success(data.responseData);
                this.getPodcastList();
            }
            else {
                this.spinner.hide();
                this.toastr.error(data.responseData, '');
            }
        }, error => {
            // this.error = error;
        });
        this.modalRef.hide();
    }
    decline() {
        // this.message = 'Declined!';
        this.modalRef.hide();
    }
    reset(f) {
        f.resetForm();
        setTimeout(() => {
            this.model.topicId = "";
            this.myInputVariable.nativeElement.value = "";
        });
    }
};
PodcastComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: ngx_spinner__WEBPACK_IMPORTED_MODULE_2__["NgxSpinnerService"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_10__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] },
    { type: ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_9__["BsModalService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('table1', { static: false })
], PodcastComponent.prototype, "table1", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('table2', { static: false })
], PodcastComponent.prototype, "table2", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('list1', { static: false })
], PodcastComponent.prototype, "list1", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('myInput', { static: false })
], PodcastComponent.prototype, "myInputVariable", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__["MatPaginator"], { static: false })
], PodcastComponent.prototype, "paginator", void 0);
PodcastComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-podcast',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./podcast.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/podcast/podcast.component.html")).default,
        providers: [_service_user_service__WEBPACK_IMPORTED_MODULE_10__["UserService"], ngx_spinner__WEBPACK_IMPORTED_MODULE_2__["NgxSpinnerService"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./podcast.component.css */ "./src/app/podcast/podcast.component.css")).default]
    })
], PodcastComponent);



/***/ }),

/***/ "./src/app/privacy-policy/privacy-policy.component.css":
/*!*************************************************************!*\
  !*** ./src/app/privacy-policy/privacy-policy.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("* {\r\n  margin: auto;\r\n  padding: 5px 20px 0px 9px;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  padding: 20px;\r\n}\r\n\r\n.container {\r\n  width: 1100px;\r\n  max-width: 100%;\r\n}\r\n\r\n.container img {\r\n    max-width: 100%;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n.container h1 {\r\n    margin: auto;\r\n    font-size: 20px;\r\n    line-height: 25px;\r\n  }\r\n\r\n.container p {\r\n    line-height: 27px;\r\n    font-size: 14px;\r\n    margin-top: 0px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n.col-half {\r\n  width: 50%;\r\n  float: left;\r\n  padding: 10px;\r\n  min-height: 120px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.col-half p {\r\n    margin: 0px;\r\n  }\r\n\r\n.container {\r\n  padding-bottom: 50px;\r\n}\r\n\r\n.container p {\r\n    line-height: 1.5;\r\n  }\r\n\r\n.container p + p {\r\n      margin-top: 8px;\r\n    }\r\n\r\n.container p + h1 {\r\n      margin-top: 18px;\r\n      padding-bottom: 2px;\r\n    }\r\n\r\n.container p a {\r\n      padding-left: 0;\r\n    }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/privacy-policy/privacy-policy.component.ts":
/*!************************************************************!*\
  !*** ./src/app/privacy-policy/privacy-policy.component.ts ***!
  \************************************************************/
/*! exports provided: PrivacyPolicyComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrivacyPolicyComponent", function() { return PrivacyPolicyComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let PrivacyPolicyComponent = class PrivacyPolicyComponent {
    constructor() { }
    ngOnInit() {
        console.log("PrivacyPolicy");
    }
};
PrivacyPolicyComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-privacy-policy',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./privacy-policy.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/privacy-policy/privacy-policy.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./privacy-policy.component.css */ "./src/app/privacy-policy/privacy-policy.component.css")).default]
    })
], PrivacyPolicyComponent);



/***/ }),

/***/ "./src/app/reset-password/reset-password.component.css":
/*!*************************************************************!*\
  !*** ./src/app/reset-password/reset-password.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Jlc2V0LXBhc3N3b3JkL3Jlc2V0LXBhc3N3b3JkLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/reset-password/reset-password.component.ts":
/*!************************************************************!*\
  !*** ./src/app/reset-password/reset-password.component.ts ***!
  \************************************************************/
/*! exports provided: ResetPasswordComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResetPasswordComponent", function() { return ResetPasswordComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ngx-spinner */ "./node_modules/ngx-spinner/fesm2015/ngx-spinner.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _service_user_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/user.service */ "./src/app/service/user.service.ts");






let ResetPasswordComponent = class ResetPasswordComponent {
    constructor(route, router, spinner, service, toastr) {
        this.route = route;
        this.router = router;
        this.spinner = spinner;
        this.service = service;
        this.toastr = toastr;
        this.loading = false;
        this.submitted = false;
        this.error = '';
        this.model = {};
    }
    ngOnInit() {
    }
    onSubmit() {
        this.spinner.show();
        let code = this.route.snapshot.queryParamMap.get('id');
        let reset = {
            "password": this.model.Password,
            "token": code
        };
        if (this.model.Password == this.model.ConfirmPassword) {
            this.service.resetPassword(reset)
                .subscribe(data => {
                this.spinner.hide();
                if (data.responseCode == 200) {
                    this.toastr.success(data.responseData);
                    setTimeout(() => {
                        this.router.navigateByUrl('/');
                    }, 5000);
                }
                else {
                    this.spinner.hide();
                    this.toastr.error(data.responseData);
                }
            }, error => {
                // this.error = error;
            });
        }
        else {
            this.spinner.hide();
            this.toastr.info('confirm password must be same as password');
        }
    }
};
ResetPasswordComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: ngx_spinner__WEBPACK_IMPORTED_MODULE_3__["NgxSpinnerService"] },
    { type: _service_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] }
];
ResetPasswordComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-reset-password',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./reset-password.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/reset-password/reset-password.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./reset-password.component.css */ "./src/app/reset-password/reset-password.component.css")).default]
    })
], ResetPasswordComponent);



/***/ }),

/***/ "./src/app/service/user.service.ts":
/*!*****************************************!*\
  !*** ./src/app/service/user.service.ts ***!
  \*****************************************/
/*! exports provided: UserService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserService", function() { return UserService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let UserService = class UserService {
    constructor(http) {
        this.http = http;
        this.currentUserSubject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        //this.EndPoint = "https://localhost:44320";
        //this.EndPoint = "http://ngoappdemo.projectstatus.in";// ------- Use for Uat/demo
        this.EndPoint = "https://www.soilhealth.net.au";
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.asObservable();
    }
    currentSyncUser() {
        try {
            return JSON.parse(localStorage.getItem('currentUser'));
        }
        catch (e) {
            console.log(e);
        }
        return null;
    }
    login(param) {
        return this.http.post(this.EndPoint + `/api/User/Login`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(VaidateUser => {
            console.log(VaidateUser);
            if (param.remember == true) {
                sessionStorage.setItem('Token', VaidateUser.responseData);
            }
            else {
                sessionStorage.removeItem('token');
            }
            let user = {
                token: VaidateUser.responseData
            };
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(VaidateUser.responseData);
            return VaidateUser;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    forgotPassword(param) {
        return this.http.post(this.EndPoint + `/api/User/ForgotPassword`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    resetPassword(param) {
        return this.http.post(this.EndPoint + `/api/User/ResetPassword`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    changePassword(param) {
        return this.http.post(this.EndPoint + `/api/User/ChangePassword`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
    getDashboard() {
        return this.http.post(this.EndPoint + `/api/User/GetDashboard`, null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    createPodcastTopic(param) {
        return this.http.post(this.EndPoint + `/api/User/CreatePodcastTopic`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    updatePodcastTopic(param) {
        return this.http.post(this.EndPoint + `/api/User/UpdatePodcastTopic`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    updateDisplayOrder(param) {
        return this.http.post(this.EndPoint + `/api/User/UpdateListDisplayOrder`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    getPodcastTopicList() {
        return this.http.post(this.EndPoint + `/api/User/GetPodcastTopiclist`, null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    getPodcastTopicByID(param) {
        return this.http.post(this.EndPoint + `/api/User/getPodcastTopicByID?id=` + param, null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    deletePodcastTopic(param) {
        return this.http.post(this.EndPoint + `/api/User/DeletePodcastTopic?id=` + param, null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    createPodcast(param) {
        const httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Content-Type': 'multipart/form-data' })
        };
        return this.http.post(this.EndPoint + `/api/User/AddPodcast`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    //createPodcast(data) {
    //  const httpOptions = {
    //    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    //  }
    //  const url = this.EndPoint + `/api/User/AddPodcast`;
    //  //let input = new FormData();
    //  //input.append('podcast', data);   // "url" as the key and "data" as value
    //  return this.http.post(url, data, httpOptions).pipe(map((resp: any) => resp));
    //}
    updatePodcast(param) {
        return this.http.post(this.EndPoint + `/api/User/UpdatePodcast`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    updatePodcastDisplayOrder(param) {
        return this.http.post(this.EndPoint + `/api/User/updatePodcastDisplayOrder`, param)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    getPodcastList() {
        return this.http.post(this.EndPoint + `/api/User/GetAllPodcast`, null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    getPodcastByID(param) {
        return this.http.post(this.EndPoint + `/api/User/GetPodcastByID?id=` + param, null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    deletePodcast(param) {
        return this.http.post(this.EndPoint + `/api/User/DeletePodcast?id=` + param, null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    handleError(error) {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(error);
    }
};
UserService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
UserService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], UserService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: true,
    SecretKey: 'Secret123456789!@#$%^&*%',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! F:\NGO\NGO.Web\admin\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map